import React from 'react';
import { DateSubheader } from '../DateSubheader';
import { BandInfoLockup, BandMember } from '../BandInfoLockup/BandInfoLockup';
import AccentButton from '../AccentButton/AccentButton';
import { CameraIcon, LinkIcon } from '../icons';
import type { PillColor } from '../DateSubheader/DateSubheader';
import './ShowPhotoCard.css';

export interface ShowPhotoCardProps {
    /** Band name to display */
    bandName: string;
    /** Band hero image URL */
    imageUrl?: string;
    /** Band members for "With" row */
    bandMembers?: BandMember[];
    /** Date label (e.g., "Sun Sep 21") */
    dateLabel: string;
    /** Time label (e.g., "12:00 PM") */
    timeLabel: string;
    /** Pill text (e.g., "Today") */
    pillLabel?: string;
    /** Pill color variant */
    pillColor?: PillColor;
    /** Callback for "Add Show Photo" button */
    onAddPhoto?: () => void;
    /** Callback for "Copy Show Link" button */
    onCopyLink?: () => void;
}

export const ShowPhotoCard: React.FC<ShowPhotoCardProps> = ({
    bandName,
    imageUrl,
    bandMembers,
    dateLabel,
    timeLabel,
    pillLabel,
    pillColor = 'red',
    onAddPhoto,
    onCopyLink,
}) => {
    return (
        <div className="show-photo-card">
            <DateSubheader
                dateLabel={dateLabel}
                pillLabel={pillLabel}
                pillColor={pillColor}
                timeLabel={timeLabel}
                showNavArrows={false}
                dateClickable={false}
            />

            <BandInfoLockup
                bandName={bandName}
                imageUrl={imageUrl}
                bandMembers={bandMembers}
            />

            <AccentButton
                shape="round"
                size="large"
                icon={<CameraIcon size="m" tone="white" />}
                onClick={(e) => {
                    e.stopPropagation();
                    onAddPhoto?.();
                }}
                className="show-photo-card__add-photo-btn"
            >
                Add Show Photo
            </AccentButton>

            <button
                className="show-photo-card__copy-link"
                onClick={(e) => {
                    e.stopPropagation();
                    onCopyLink?.();
                }}
            >
                <LinkIcon size="s" tone="lightGrey" />
                <span>Copy Show Link</span>
            </button>
        </div>
    );
};
